import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-help-header-popup',
  templateUrl: './help-header-popup.component.html',
  styleUrls: ['./help-header-popup.component.scss']
})
export class HelpHeaderPopupComponent implements OnInit {
  
  constructor(public dialogRef: MatDialogRef<HelpHeaderPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

}
